import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Лечебно оздоровительный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид туризма, совершаемый с оздоровительными или лечебными целями.</p>
                    <p>Высококвалифицированные специалисты, качественное медицинское обслуживание способствуют развитию
                        оздоровительного туризма в санаториях, домах отдыха и лечебных учреждениях Брестской
                        области.</p>
                    <p>Наиболее востребованными являются предложения по отдыху в санаториях, которых насчитывается на
                        территории нашей области 33. Общей отличительной чертой абсолютно для всех санаториев является
                        их дислокация – как правило, они расположены в красивых и привлекательных местах, среди лесов,
                        на берегах рек и озер, где пейзажи и окружающая природа сама по себе оказывает умиротворяющее и
                        лечебное действие. Спектр медицинских услуг и процедур широк, оборудование вполне современное,
                        практикуются разнообразные ванны, грязелечение, спа-процедуры, массажи и прочее.</p>
                </div>
            </div>
        </>
    );
}